module.exports = __webpack_public_path__ + "static/media/ATHENA DAC.a639408b.png";